import React from "react";
import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { Icon } from "@UI/Components/Icon/Icon";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { BrandPlus } from "@UI/Components/Icons/BrandPlus";
import { Box } from "@UI/Components/Box/Box";
import { Button } from "@UI/Components/Button/Button";
import useThemeToken from "@UI/hooks/useThemeToken";
import { List, ListItem, ListIcon } from "@UI/Components/List/List";
import { Check } from "@UI/Components/Icons/Check";
import messages from "./messages";

interface Props {
  isOpen: boolean;
  handleConfirm: () => void;
  onClose: () => void;
  isMobile: boolean;
}

export const RingtwicePlusAdvantagesModal = ({
  isOpen,
  handleConfirm,
  onClose,
  isMobile,
}: Props) => {
  const pink500 = useThemeToken("colors", "pink.500");
  const orange500 = useThemeToken("colors", "orange.500");
  const pink600 = useThemeToken("colors", "pink.600");
  const orange600 = useThemeToken("colors", "orange.600");

  const advantagesTitles = [
    "ringtwice_plus_advantage_one_closure",
    "ringtwice_plus_advantage_two_closure",
    "ringtwice_plus_advantage_three_closure",
    "ringtwice_plus_advantage_four_closure",
  ];

  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={() => onClose()}
      isCentered={isMobile ? false : true}
    >
      <Box>
        <Heading as="h2" marginRight="3" mb={2}>
          <FormattedMessage
            {...messages.ringtwicePlus}
            values={{
              plus: () => (
                <Icon
                  as={BrandPlus}
                  boxSize="5"
                  marginLeft="1"
                  display="inline"
                />
              ),
            }}
          />
        </Heading>
        <Text>
          <FormattedMessage {...messages.subtitleAdvantages} />
        </Text>
        <Box>
          <List spacing="1">
            {advantagesTitles.map((advantage, index) => (
              <ListItem
                key={`advantage-${index}`}
                display="flex"
                alignItems="start"
              >
                <ListIcon as={Check} color="green.500" marginTop="xs" />
                <Box marginLeft="2">
                  <FormattedMessage {...messages[advantage]} />
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>
        <Button
          colorScheme="pink"
          size="lg"
          width="full"
          mb={2}
          onClick={handleConfirm}
          background={`linear-gradient(96.51deg, ${pink500} 0%, ${orange500} 99.87%);`}
          _hover={{
            background: `linear-gradient(96.51deg, ${orange600} 0%, ${pink600} 99.87%);`,
          }}
        >
          <FormattedMessage {...messages.discover} />
        </Button>
      </Box>
    </ResponsiveModal>
  );
};
